import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../analytics';

// Componente invisible que dispara un evento page_view cada vez que
// cambia la ruta. Necesario porque en una SPA la navegación no recarga
// la página y Analytics no lo detecta solo.
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
